module.exports = __webpack_public_path__ + "static/media/TY OS.8537c9b9.jpeg";